export default "<button title=\"{{caption}}\" class=\"btn btn-success\" (click)=\"Upload()\" [disabled]=\"disabled\">{{caption}}</button>";